"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductsViewQueryParamsSync = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const products_view_query_params_hydrators_map_1 = require("./products-view-query-params-hydrators.map");
const products_view_query_params_constants_1 = require("./products-view-query-params.constants");
const products_view_query_params_mappers_1 = require("./products-view-query-params.mappers");
const view_query_params_1 = require("../../../../../common/view-query-params");
const products_table_1 = require("../../../../../store/catalogs/products-table");
const store_1 = require("../../../../../../store");
const useProductsViewQueryParamsSync = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const catalogId = (0, store_1.useSelectedCatalogId)();
    const projectId = (0, store_1.useSelectedProjectId)();
    const filter = (0, products_table_1.useProductsTableFilter)();
    const search = (0, products_table_1.useProductsTableSearch)();
    const sort = (0, products_table_1.useProductsTableSort)();
    const pageSize = (0, products_table_1.useProductsTablePageSize)();
    const dynamicColumns = (0, products_table_1.useProductsTableDynamicColumns)();
    const middleSectionFilter = (0, store_1.useSelectedAttributeNode)();
    const attributesCollapseState = (0, store_1.useAttributesCollapseState)();
    const expandedAttributes = (0, store_1.useExpandedAttributes)();
    const expandedNodes = (0, store_1.useExpandedNodes)();
    const selectedTreeNodePath = (0, store_1.useSelectedTreeNodePath)();
    const productTreeRootNodeId = (0, store_1.useProductTreeRootNodeId)();
    const defaults = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, products_view_query_params_constants_1.productsTableQueryStateDefaults), { [view_query_params_1.ViewQueryStateField.SelectedTreeNodePath]: productTreeRootNodeId })), [productTreeRootNodeId]);
    const viewState = (0, react_1.useMemo)(() => (0, products_view_query_params_mappers_1.getProductsViewQueryState)({
        catalogId,
        dynamicColumns,
        filter,
        middleSectionFilter,
        pageSize,
        projectId,
        search,
        selectedTreeNodePath,
        sort,
    }), [catalogId, dynamicColumns, filter, middleSectionFilter, pageSize, projectId, search, selectedTreeNodePath, sort]);
    const handleHydrate = (0, react_1.useCallback)((state) => {
        if (!catalogId)
            return;
        (0, products_view_query_params_hydrators_map_1.hydrateProductsTableQueryState)({
            attributesCollapseState,
            catalogId,
            dispatch,
            expandedAttributes,
            expandedNodes,
            state,
        });
    }, [attributesCollapseState, catalogId, dispatch, expandedAttributes, expandedNodes]);
    const shouldHydrate = (0, react_1.useCallback)((state) => (state[view_query_params_1.ViewQueryStateField.ProjectId] === projectId
        && state[view_query_params_1.ViewQueryStateField.CatalogId] === catalogId), [catalogId, projectId]);
    return (0, view_query_params_1.useViewQueryParamsSync)({
        defaults,
        enabled: Boolean(projectId && catalogId),
        onHydrate: handleHydrate,
        shouldHydrate,
        viewState,
    });
};
exports.useProductsViewQueryParamsSync = useProductsViewQueryParamsSync;
